"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBibliographicReferenceUrl = exports.isValidBibliographicReferenceUrl = void 0;
var isValidBibliographicReferenceUrl = function (url) {
    try {
        var protocol = new URL(url.trim()).protocol;
        return protocol === 'http:' || protocol === 'https:';
    }
    catch (_a) {
        return false;
    }
};
exports.isValidBibliographicReferenceUrl = isValidBibliographicReferenceUrl;
var getBibliographicReferenceUrl = function (reference) {
    if (!reference.url || !(0, exports.isValidBibliographicReferenceUrl)(reference.url)) {
        return undefined;
    }
    return reference.url.trim();
};
exports.getBibliographicReferenceUrl = getBibliographicReferenceUrl;
//# sourceMappingURL=bibliographicReference.js.map